import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { css } from 'styled-components';
function display() {
  var bands = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "block";
  var result = [];
  if (!bands.length) {
    return result;
  }
  var normed = normalize(bands, defaultValue);
  for (var i = 0; i < normed.length; i++) {
    var _normed$i = _slicedToArray(normed[i], 2),
      minWidth = _normed$i[0],
      display2 = _normed$i[1];
    result.push(css(["@media (min-width:", "px){display:", ";}"], minWidth, display2));
  }
  return result;
}
function append(items, band) {
  if (items.length && items[items.length - 1][1] === band[1]) {
    return;
  }
  items.push(band);
}
function normalize(bands, defaultDisplay) {
  var result = [];
  var prev;
  if (typeof bands[0] === "number" && bands[0] !== 0) {
    prev = [0, "none"];
    append(result, prev);
  }
  for (var i = 0; i < bands.length; i++) {
    var b = bands[i];
    if (typeof b !== "number") {
      prev = b;
      append(result, prev);
      continue;
    }
    if (!prev) {
      prev = [b, defaultDisplay];
      append(result, prev);
      continue;
    }
    prev = [b, prev[1] === "none" ? defaultDisplay : "none"];
    append(result, prev);
  }
  return result;
}
export { display };